var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDataStopped(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 17,
    viewBox: "0 0 80 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.49902H30",
    stroke: "#B6B6B6",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 16.0664L41.6816 0.93388",
    stroke: "#B6B6B6",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8408 16.0664L46.5224 0.93388",
    stroke: "#B6B6B6",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50 8.49902H80",
    stroke: "#B6B6B6",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDataStopped);
export default __webpack_public_path__ + "static/media/icon_data_stopped.ff7a9012c37b8cf959c78a29481bcfa9.svg";
export { ForwardRef as ReactComponent };